'use strict';

const analyticsBookingCategory = 'Booking';
const analyticsBookAction = 'RequestedToBook';
const analyticsAcceptAction = 'AcceptedBookingRequest';
const analyticsDeclineAction = 'DeclinedBookingRequest';
const analyticsCancelAction = 'CanceledBookingRequest';
const analyticsBookingPopupAction = 'OpenedBookingPopup';

export default function bookings($rootScope, $http, $q, utils, userModel, modal, analytics, lazyLoadBookingModal) {
  'ngInject';

  return {

    lazyLoadBookingModal: lazyLoadBookingModal.load,

    createBooking: function (guideId, bookingData) {
      return new $q((resolve, reject) => {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + guideId + '/create'), bookingData)
          .then((response) => {
            analytics.track(analyticsBookAction, {
              category: analyticsBookingCategory,
              value: '0.00',
              currency: 'USD'
            });

            resolve(response.data);
          })
          .catch(reject);
      });
    },

    modify: function (conversationId, bookingData) {
      var postData = {
        bookingId: bookingData.bookingId,
        date: bookingData.date,
        hours: bookingData.hours
      };

      return new $q((resolve, reject) => {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + conversationId + '/modify'), postData)
          .then((response) => {
            resolve(response.data);
          })
          .catch(reject);
      });
    },

    accept: function (conversationId, type = 'discuss') {
      const postData = { type };

      return new $q((resolve, reject) => {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + conversationId + '/accept'), postData)
          .then((response) => {
            resolve(response.data);
            analytics.track(analyticsAcceptAction, {
              category: analyticsBookingCategory
            });
          })
          .catch(reject);
      });
    },

    acceptOffer: function (conversationId, message) {

      return new $q((resolve, reject) => {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + conversationId + '/offer_accept'), { message: message })
          .then((response) => {
            resolve(response.data);
            analytics.track(analyticsAcceptAction, {
              category: analyticsBookingCategory
            });
          })
          .catch(reject);
      });
    },

    confirmTour: function (bookingId, participantId, action) {
      const postData = { action, bookingId };
      $http.post(utils.getApiUrlV2(`bookings/${userModel.item.id}
/log_booking_confirm_action/${participantId}`), postData);
    },

    decline: function (conversationId) {
      return new $q((resolve, reject) => {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + conversationId + '/decline'))
          .then((response) => {
            analytics.track(analyticsDeclineAction, {
              category: analyticsBookingCategory
            });
            resolve(response.data);
          })
          .catch(reject);
      });
    },

    declineOffer: function (conversationId) {
      return new $q((resolve, reject) => {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + conversationId + '/offer_decline'))
          .then((response) => {
            analytics.track(analyticsDeclineAction, {
              category: analyticsBookingCategory
            });
            resolve(response.data);
          })
          .catch(reject);
      });
    },


    cancel: function (conversationId) {
      return new $q((resolve, reject) => {
        $http.post(utils.getApiUrlV2('bookings/' + userModel.item.id + '/' + conversationId + '/cancel'))
          .then((response) => {
            analytics.track(analyticsCancelAction, {
              category: analyticsBookingCategory
            });
            resolve(response.data);
          })
          .catch(reject);
      });
    },

    showBookingModal: function (guide, booking) {
      return this.lazyLoadBookingModal().then(() => {
        return this.openModal(guide, booking);
      });
    },

    openModal: function (guide, booking) {
      var modalScope = $rootScope.$new();
      var modalInstance;

      modalScope.guide = guide;
      modalScope.booking = booking || {};

      modalInstance = modal.open({
        template: '<booking-form guide="guide" booking="booking" done="close(booking)"></booking-form>',
        scope: modalScope
      });

      analytics.track(analyticsBookingPopupAction, {
        category: analyticsBookingCategory
      });

      return new $q((resolve, reject) => {
        modalInstance.result
          .then(resolve)
          .catch(reject)
          .finally(() => {
            modalInstance.close();
          });
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/common/booking_form/bookings.js